import { render } from "./VHeroSection.vue?vue&type=template&id=10661027&scoped=true"
const script = {}

import "./VHeroSection.vue?vue&type=style&index=0&id=10661027&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10661027"]])

export default __exports__